
(function () {
  function announcementSlider(root = document) {
    if (typeof Swiper === 'undefined') return;

    const sliders = [];

    if (root.matches && root.matches('.announcement-slider')) {
      sliders.push(root);
    }

    sliders.push(
      ...root.querySelectorAll('.announcement-slider')
    );

    sliders.forEach((slider) => {
      // Prevent duplicate Swiper initialization
      if (slider.swiper && !slider.swiper.destroyed) {
        return;
      }

      const speed = Number(slider.dataset.speed) || 300;
      const changeSpeed = Number(slider.dataset.changeSpeed) || 5000;
      const slidesPerView = Number(slider.dataset.slidesPerView) || 1;
      const rotate = slider.dataset.rotate === 'true';

      const swiperOptions = {
        loop: true,
        slidesPerView: 1,
        spaceBetween: 20,
        grabCursor: true,
        longSwipesRatio: 0.3,
        speed: speed,
        breakpoints: {
          750: {
            slidesPerView: slidesPerView === 1 ? 1 : 2
          },
          1025: {
            slidesPerView: slidesPerView,
            spaceBetween: 30
          }
        }
      };

      if (rotate) {
        swiperOptions.autoplay = {
          delay: changeSpeed
        };
      }

      new Swiper(slider, swiperOptions);
    });
  }

  // Initialize once when the page loads
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      announcementSlider();
    }, { once: true });
  } else {
    announcementSlider();
  }

  // Initialize newly loaded sections in Shopify editor
  document.addEventListener('shopify:section:load', function (event) {
    announcementSlider(event.target);
  });

  // Clean up when a section is removed in Shopify editor
  document.addEventListener('shopify:section:unload', function (event) {
    event.target
      .querySelectorAll('.announcement-slider')
      .forEach((slider) => {
        if (slider.swiper && !slider.swiper.destroyed) {
          slider.swiper.destroy(true, true);
        }
      });
  });

})();
